module.exports = "../dist/img/product-detail-3-32.b2fd.jpg";